import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { TranslatePipe } from '@core/i18n-legacy';

@Component({
  selector: 'rtr-sign-up-button',
  templateUrl: './sign-up-button.component.html',
  styleUrls: ['./sign-up-button.component.less'],
  imports: [RouterLink, TranslatePipe],
})
export class SignUpButtonComponent {}
